// tslint:disable:max-line-length
export const HTML5_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// tslint:enable:max-line-length

export function validateEmail(
  email?: string,
  required: boolean = true
): string | undefined {
  if (!email) {
    return required ? `Email is required` : undefined;
  }

  if (!HTML5_EMAIL_REGEX.test(email || '')) {
    return `Email must be valid`;
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./src/app/validators/email.ts